import Link from "next/link";
import { useSearchParams } from "next/navigation";

import { Tag } from "@/app/utils/interface";

interface TagFilterProps {
  tags: Tag[];
  selectedTag?: string;
}

const TagFilter = ({ tags, selectedTag }: TagFilterProps) => {
  const searchParams = useSearchParams();

  const createTagUrl = (tagSlug: string) => {
    const params = new URLSearchParams(searchParams.toString());
    if (tagSlug === selectedTag) {
      params.delete("tag");
    } else {
      params.set("tag", tagSlug);
      params.delete("page"); // Reset to first page when changing tag
    }
    return `?${params.toString()}`;
  };

  return (
    <div className="flex flex-wrap gap-2">
      <Link
        href="?"
        className={`rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
          !selectedTag
            ? "bg-black text-white"
            : "bg-gray-100 text-gray-700 hover:bg-black hover:text-white"
        }`}
      >
        All
      </Link>
      {tags.map((tag) => (
        <Link
          key={tag._id}
          href={createTagUrl(tag.slug.current)}
          className={`rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
            selectedTag === tag.slug.current
              ? "bg-black text-white"
              : "bg-gray-100 text-gray-700 hover:bg-black hover:text-white"
          }`}
        >
          {tag.name} ({tag.postCount})
        </Link>
      ))}
    </div>
  );
};

export default TagFilter;
